module.exports = __webpack_public_path__ + "static/assets/cdcc397dfb265848005cfb076682ed18.svg";